import type { HelpArticle } from '../types';

export const BILLING_ARTICLES: HelpArticle[] = [
    {
        slug: 'planos-e-teste-gratis',
        topicId: 'billing',
        title: 'Planos e período de teste',
        description:
            'Como funciona o teste grátis de 14 dias, o que cada plano inclui e como assinar.',
        updatedAt: '2026-07-03',
        keywords: ['plano', 'assinatura', 'teste grátis', 'trial', 'assinar', 'preço'],
        blocks: [
            {
                type: 'paragraph',
                text: 'Toda conta nova começa com **14 dias de teste grátis**, sem cartão de crédito. Nesse período você usa os recursos essenciais dentro dos limites do teste, o suficiente para criar um laudo completo e sentir a plataforma.',
            },
            { type: 'subheading', id: 'o-que-muda', text: 'O que muda entre os planos' },
            {
                type: 'paragraph',
                text: 'Os planos se diferenciam principalmente pelo volume de trabalho que liberam por mês: quantidade de **laudos**, **créditos de IA**, **correções automáticas de testes** e **envios de testes e questionários**. Planos maiores também liberam recursos como personalização completa do laudo, seções customizadas e mais templates próprios.',
            },
            {
                type: 'callout',
                tone: 'info',
                text: 'Os valores e o detalhamento de cada plano estão sempre atualizados na página **Assinatura**, dentro da plataforma, e no site laudopsi.com.',
            },
            { type: 'subheading', id: 'como-assinar', text: 'Como assinar' },
            {
                type: 'steps',
                items: [
                    'No menu lateral, abra **Assinatura**.',
                    'Compare os planos e clique no que faz sentido para a sua rotina.',
                    'Conclua o pagamento com cartão. A liberação é imediata.',
                ],
            },
            {
                type: 'paragraph',
                text: 'A cobrança é mensal e você pode trocar de plano quando quiser. O guia **Alterar plano, faturas e pagamento** mostra como.',
            },
        ],
    },
    {
        slug: 'creditos-de-ia-e-limites',
        topicId: 'billing',
        title: 'Entenda os créditos de IA e os limites do plano',
        description:
            'O que consome créditos, onde acompanhar o uso e o que acontece quando um limite é atingido.',
        updatedAt: '2026-07-03',
        keywords: ['créditos', 'ia', 'limites', 'quota', 'uso', 'consumo'],
        blocks: [
            {
                type: 'paragraph',
                text: 'Os recursos de IA do LaudoPsi funcionam com **créditos mensais** incluídos no seu plano. Cada vez que você gera um rascunho de seção ou melhora um texto, uma quantidade de créditos é consumida.',
            },
            { type: 'subheading', id: 'o-que-consome', text: 'O que consome créditos' },
            {
                type: 'list',
                items: [
                    'Gerações completas de seção, como demanda, história clínica, diagnóstico e recomendações.',
                    'Melhorias de texto dentro do editor, que consomem menos créditos que uma geração completa.',
                    'Processamentos mais pesados, como a leitura da anamnese enviada.',
                ],
            },
            { type: 'subheading', id: 'outros-limites', text: 'Os outros limites' },
            {
                type: 'paragraph',
                text: 'Além dos créditos de IA, cada plano define a quantidade mensal de **laudos**, de **correções automáticas de testes** e de **envios de testes e questionários** para pacientes.',
            },
            { type: 'subheading', id: 'acompanhar', text: 'Onde acompanhar o uso' },
            {
                type: 'paragraph',
                text: 'Abra **Assinatura** no menu lateral. A tabela de **limites do plano** mostra quanto você já usou de cada recurso no período atual.',
            },
            {
                type: 'callout',
                tone: 'info',
                text: 'Atingiu um limite no meio de uma avaliação importante? Você pode migrar para um plano maior a qualquer momento e a liberação é imediata.',
            },
        ],
    },
    {
        slug: 'alterar-plano-e-faturas',
        topicId: 'billing',
        title: 'Alterar plano, faturas e pagamento',
        description:
            'Como trocar de plano, consultar faturas e resolver problemas com o pagamento.',
        updatedAt: '2026-07-03',
        keywords: ['alterar plano', 'fatura', 'pagamento', 'cartão', 'cancelar', 'upgrade'],
        blocks: [
            { type: 'subheading', id: 'trocar', text: 'Trocando de plano' },
            {
                type: 'steps',
                items: [
                    'Abra **Assinatura** no menu lateral.',
                    'Clique em **Alterar plano** e escolha o novo plano.',
                    'Confirme. Migrações para planos maiores liberam os novos limites na hora.',
                ],
            },
            { type: 'subheading', id: 'faturas', text: 'Consultando faturas' },
            {
                type: 'paragraph',
                text: 'Na mesma página de **Assinatura** fica o histórico de faturas, com data, valor e status de cada cobrança.',
            },
            { type: 'subheading', id: 'problemas', text: 'Problemas com pagamento' },
            {
                type: 'paragraph',
                text: 'Se uma cobrança falhar, verifique o limite e a validade do cartão cadastrado. Persistindo o problema, abra um chamado no **Suporte** com o print da fatura, e nossa equipe investiga com prioridade.',
            },
            {
                type: 'callout',
                tone: 'info',
                text: 'Precisa cancelar ou mudar a forma de pagamento? Gerencie tudo pela página Assinatura. Em caso de dúvida, o suporte resolve com você.',
            },
        ],
    },
];
